export const footerTranslations = {
    es: {
        footer: {
            tagline: "Fluidez Clínica Redefinida.",
            privacy: "Privacidad",
            terms: "Términos",
            contact: "Contacto"
        }
    },
    en: {
        footer: {
            tagline: "Clinical Fluency Redefined.",
            privacy: "Privacy",
            terms: "Terms",
            contact: "Contact"
        }
    }
};
